module.exports = __webpack_public_path__ + "static/img/1-1.213f9d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/1-1.png
// module id = b04t
// module chunks = 0